import React from 'react'
import { useState } from 'react'
import { useRef } from 'react'
import { ReactComponent as Threedots } from '../../assets/images/threedots.svg'

const FlottedButton = ({ children }) => {
    // const [hovered, setHovered] = useState(false)
    // const toggleHover = () => setHovered(!hovered)

    return (
        <div class="multi-space">
            <div class="multishare-box">
                <button
                    class="action-btn btn btn-dark"
                    id="btnv"
                    // onMouseEnter={toggleHover}
                    // onMouseLeave={toggleHover}
                >
                    <Threedots />
                    <ul
                        // class={`social-icons ${hovered ? 'mystyle' : ''}`}
                        class="social-icons"
                        id="inner2"
                    >
                        {children}
                    </ul>
                </button>
            </div>
        </div>
    )
}

export default FlottedButton
